import * as Action from '../actions/TTSAction';

export enum TTSStatus {
  Idle,
  Playing,
  Paused,
}

export interface SpeechState {
  status: TTSStatus;
  rate: number;
}

export function initSpeechState(): SpeechState {
  return {
    status: TTSStatus.Idle,
    rate: 1,
  };
}

export function speech(state: SpeechState, action: Action.TTSAction): SpeechState {
  switch (action.type) {
    case Action.TTS_PLAY:
      return { ...state, status: TTSStatus.Playing };
    case Action.TTS_PAUSE:
      return { ...state, status: TTSStatus.Paused };
    case Action.TTS_RESUME:
      return { ...state, status: TTSStatus.Playing };
    case Action.TTS_RESET:
      return { ...state, status: TTSStatus.Idle };
    case Action.TTS_RATE_CHANGE:
      return { ...state, rate: action.rate };
  }
}
